(function() {

  'use strict';


  /* =====================================================
     PRODUCT IMAGE SLIDER
  ===================================================== */

  document.querySelectorAll('[data-product-slider]').forEach(function(slider) {

    const slides = Array.from(
      slider.querySelectorAll('[data-product-slide]')
    );

    const dots = Array.from(
      slider.querySelectorAll('[data-slider-dot]')
    );

    const prevButton =
      slider.querySelector('[data-slider-prev]');

    const nextButton =
      slider.querySelector('[data-slider-next]');

    if (slides.length <= 1) {
      return;
    }


    let currentIndex = 0;


    function showSlide(index) {

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;


      slides.forEach(function(slide, i) {

        slide.classList.toggle(
          'is-active',
          i === currentIndex
        );

      });


      dots.forEach(function(dot, i) {

        dot.classList.toggle(
          'is-active',
          i === currentIndex
        );

      });

    }


    if (prevButton) {

      prevButton.addEventListener(
        'click',
        function(event) {

          event.preventDefault();
          event.stopPropagation();

          showSlide(currentIndex - 1);

        }
      );

    }


    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function(event) {

          event.preventDefault();
          event.stopPropagation();

          showSlide(currentIndex + 1);

        }
      );

    }


    dots.forEach(function(dot) {

      dot.addEventListener(
        'click',
        function(event) {

          event.preventDefault();
          event.stopPropagation();

          showSlide(
            Number(this.dataset.sliderDot)
          );

        }
      );

    });


    slider.addEventListener(
      'keydown',
      function(event) {

        if (event.key === 'ArrowLeft') {
          showSlide(currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          showSlide(currentIndex + 1);
        }

      }
    );

  });



  /* =====================================================
     CART HELPERS
  ===================================================== */

  async function refreshCart() {

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart.js',
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error('Unable to refresh cart');
      }

      return await response.json();

    } catch (error) {

      console.error(
        'Cart refresh error:',
        error
      );

      return null;

    }

  }



  /* =====================================================
     OPEN CART DRAWER
  ===================================================== */

  function openCartDrawer(cart) {

    /*
     * Your custom cart drawer
     */
    if (
      window.CartDrawer &&
      typeof window.CartDrawer.open === 'function'
    ) {

      window.CartDrawer.open();

    }


    /*
     * Send cart data to the drawer.
     */
    if (cart) {

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail: {
              cart: cart
            }
          }
        )
      );

    }


    /*
     * Generic Shopify/theme cart event.
     */
    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          detail: {
            cart: cart
          }
        }
      )
    );

  }



  /* =====================================================
     BUTTON SUCCESS STATE
  ===================================================== */

  function showAddedState(button) {

    if (!button) {
      return;
    }

    button.classList.add(
      'is-added'
    );

    button.innerHTML =
      'Added <span class="custom-product-card__added-icon" aria-hidden="true">✓</span>';

  }



  /* =====================================================
     DIRECT SINGLE-VARIANT ADD
  ===================================================== */

  document
    .querySelectorAll('[data-quick-add-single]')
    .forEach(function(button) {


      button.addEventListener(
        'click',
        async function(event) {

          event.preventDefault();
          event.stopPropagation();


          /*
           * Prevent double clicks.
           */
          if (button.disabled) {
            return;
          }


          const variantId =
            Number(
              button.dataset.variantId
            );


          if (!variantId) {
            return;
          }


          const originalHTML =
            button.innerHTML;


          button.disabled = true;

          button.classList.add(
            'is-loading'
          );

          button.textContent =
            'Adding...';


          try {


            /*
             * Add exactly ONE item.
             */
            const response =
              await fetch(
                window.Shopify.routes.root +
                'cart/add.js',
                {
                  method: 'POST',

                  headers: {
                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'
                  },

                  body: JSON.stringify({

                    items: [
                      {
                        id: variantId,
                        quantity: 1
                      }
                    ]

                  })

                }
              );


            if (!response.ok) {

              const errorData =
                await response
                  .json()
                  .catch(function() {
                    return {};
                  });

              throw new Error(
                errorData.description ||
                'Unable to add product'
              );

            }


            /*
             * Consume response.
             */
            await response.json();


            /*
             * Get fresh cart data.
             */
            const cart =
              await refreshCart();


            /*
             * Show Added ✓
             */
            showAddedState(button);


            /*
             * Refresh/open drawer.
             */
            openCartDrawer(cart);


            /*
             * Keep success state briefly.
             */
            setTimeout(
              function() {

                button.disabled = false;

                button.classList.remove(
                  'is-loading'
                );

                /*
                 * Keep Added state.
                 *
                 * If you want it to return
                 * to Quick Add instead,
                 * uncomment the next two lines.
                 */

                // button.innerHTML = originalHTML;
                // button.classList.remove('is-added');

              },
              1200
            );


          } catch (error) {

            console.error(
              'Single variant Quick Add error:',
              error
            );


            button.disabled = false;

            button.classList.remove(
              'is-loading'
            );

            button.innerHTML =
              originalHTML;

          }

        }
      );

    });



  /* =====================================================
     MULTI-VARIANT MODAL
  ===================================================== */

  document
    .querySelectorAll('[data-quick-add-modal]')
    .forEach(function(button) {


      const card =
        button.closest(
          '.custom-product-card'
        );


      if (!card) {
        return;
      }


      const modal =
        card.querySelector(
          '[data-variant-modal]'
        );


      if (!modal) {
        return;
      }


      const closeButtons =
        modal.querySelectorAll(
          '[data-modal-close]'
        );


      const addButton =
        modal.querySelector(
          '[data-modal-add]'
        );


      const variantSelect =
        modal.querySelector(
          '[data-variant-select]'
        );


      /* =================================================
         OPEN MODAL
      ================================================= */

      button.addEventListener(
        'click',
        function(event) {

          event.preventDefault();
          event.stopPropagation();


          modal.classList.add(
            'is-active'
          );


          modal.setAttribute(
            'aria-hidden',
            'false'
          );


          document.body.style.overflow =
            'hidden';

        }
      );


      /* =================================================
         CLOSE MODAL
      ================================================= */

      function closeModal() {

        modal.classList.remove(
          'is-active'
        );


        modal.setAttribute(
          'aria-hidden',
          'true'
        );


        if (
          !document.querySelector(
            '.custom-product-card__modal.is-active'
          )
        ) {

          document.body.style.overflow =
            '';

        }

      }


      closeButtons.forEach(
        function(closeButton) {

          closeButton.addEventListener(
            'click',
            function(event) {

              event.preventDefault();

              closeModal();

            }
          );

        }
      );


      /* =================================================
         ESC KEY
      ================================================= */

      modal.addEventListener(
        'keydown',
        function(event) {

          if (event.key === 'Escape') {

            closeModal();

          }

        }
      );


      /* =================================================
         MULTI-VARIANT ADD TO CART
      ================================================= */

      if (addButton) {

        addButton.addEventListener(
          'click',
          async function(event) {

            event.preventDefault();


            let variantId = null;


            if (
              variantSelect &&
              variantSelect.tagName === 'SELECT'
            ) {

              variantId =
                variantSelect.value;

            }

            else if (variantSelect) {

              variantId =
                variantSelect.value;

            }


            if (!variantId) {
              return;
            }


            const originalText =
              addButton.textContent;


            addButton.disabled =
              true;


            addButton.textContent =
              'Adding...';


            try {


              /*
               * Always add exactly ONE.
               */
              const response =
                await fetch(
                  window.Shopify.routes.root +
                  'cart/add.js',
                  {
                    method: 'POST',

                    headers: {
                      'Content-Type':
                        'application/json',

                      'Accept':
                        'application/json'
                    },

                    body: JSON.stringify({

                      items: [
                        {
                          id:
                            Number(variantId),

                          quantity: 1
                        }
                      ]

                    })

                  }
                );


              if (!response.ok) {

                const errorData =
                  await response
                    .json()
                    .catch(function() {
                      return {};
                    });

                throw new Error(
                  errorData.description ||
                  'Unable to add product'
                );

              }


              await response.json();


              /*
               * Get fresh cart.
               */
              const cart =
                await refreshCart();


              /*
               * Success state.
               */
              addButton.innerHTML =
                'Added <span aria-hidden="true">✓</span>';


              /*
               * Update/open cart drawer.
               */
              openCartDrawer(cart);


              /*
               * Close modal.
               */
              setTimeout(
                function() {

                  closeModal();

                  addButton.textContent =
                    originalText;

                  addButton.disabled =
                    false;

                },
                900
              );


            } catch (error) {

              console.error(
                'Quick Add error:',
                error
              );


              addButton.textContent =
                'Try Again';


              setTimeout(
                function() {

                  addButton.textContent =
                    originalText;

                  addButton.disabled =
                    false;

                },
                1500
              );

            }

          }
        );

      }

    });


})();